export default "__VITE_PUBLIC_ASSET__501ac8d4__"